import { render, staticRenderFns } from "./TreeCategory.vue?vue&type=template&id=fc5c6a02&"
import script from "./TreeCategory.vue?vue&type=script&lang=js&"
export * from "./TreeCategory.vue?vue&type=script&lang=js&"
import style0 from "./TreeCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports